<template>
  <div class="plan-type">
    <a
      v-if="$store.state.liveMode && props.date !== '' && props.date !== null &&  new Date(`${props.date} EST`).getTime() > new Date().getTime()"
      :class="{ first }"
      @mouseover="active = true"
      @mouseout="active = false"
    >
      <PlanTypeInfo
        :active="active"
        :title="title"
        :starting="starting"
        :per="per"
        :hasDisclaimer="hasDisclaimer"
        :description="description"
        :image="image"
        :icon="icon"
      />
    </a>
    <a
      v-else-if="link?.includes('http')"
      target="_blank"
      :href="link"
      :class="{ first }"
      @mouseover="active = true"
      @mouseout="active = false"
    >
      <PlanTypeInfo
        :active="active"
        :title="title"
        :starting="starting"
        :per="per"
        :hasDisclaimer="hasDisclaimer"
        :description="description"
        :image="image"
        :icon="icon"
      />
    </a>
    <router-link
      v-else
      :to="{ name: link }"
      :class="{ first }"
      @mouseover="active = true"
      @mouseout="active = false"
    >
      <PlanTypeInfo
        :active="active"
        :title="title"
        :starting="starting"
        :per="per"
        :hasDisclaimer="hasDisclaimer"
        :description="description"
        :image="image"
        :icon="icon"
      />
    </router-link>
    <div v-if="starting.toLowerCase().includes('coming soon')" class="date">
      <p>Coming Soon</p>
    </div>
    <div v-else-if="props.date !== '' && props.date !== null" class="date">
      <p>Coming {{ format(new Date(`${props.date.replace(/-/g, "/")} EST`), "MMMM yyyy") }}</p>
    </div>
  </div>
</template>

<script setup>
import { format } from "date-fns";
import PlanTypeInfo from "@/components/PlanTypeInfo";
import { ref } from "vue";
const props = defineProps({
  first: Boolean,
  hasDisclaimer: Boolean,
  title: String,
  to: String,
  starting: String,
  per: String,
  description: String,
  image: String,
  date: {
    type: String,
    default: "",
  },
  link: {
    type: String,
    default: "",
  },
  icon: {
    type: String,
    default: "",
  },
});
const active = ref(false);

</script>

<style lang="scss" scoped>
.plan-type {
  position: relative;
  &:hover {
    a,
    button {
      box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.2);
    }
    .date {
      opacity: 0;
    }
    :deep() .description {
      transition: all 0.5s 0.1s, height 0.5s 0s;
      transform: scale(1) translateY(0);
      opacity: 1;
    }
  }
}
.date {
  padding: 13px 26px;
  font-family: "United Sans Cd Hv";
  font-weight: 900;
  font-size: 1rem;
  line-height: 0.94;
  position: absolute;
  left: 17px;
  top: 40%;
  background: #fff;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #0076b6;
  transition: all 0.2s;
  pointer-events: none;
  &:before {
    content: "";
    position: absolute;
    left: 0;
    bottom: -5px;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #bbb;
    transform: rotateZ(225deg);
  }
  &:after {
    content: "";
    position: absolute;
    right: -29px;
    top: 12px;
    width: 0;
    height: 0;    

    border-left: 29px solid transparent;
    border-right: 29px solid transparent;
    border-top: 29px solid #fff;
    transform: rotateZ(45deg);
    transform-origin: center bottom;

    transform-origin: middle bottom;
  }
}
a,
button {
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  flex-direction: column;
  background-color: #fff;
  color: #0076b6;
  text-transform: uppercase;
  font-weight: bold;
  position: relative;
  flex-direction: column;
  align-items: center;
  clip-path: url(#planType);
  width: 375px;
  height: 430px;
  user-select: none;
  &.first {
    clip-path: url(#planTypeFirst);
  }
}
</style>